import React, { useEffect, useState, useMemo } from 'react'
import Workflow from './Workflow'
import { timelineService } from '../../services/timelineService'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useNavigate } from 'react-router-dom'

const considerDelegation = (pdData, delegationTracker) => {
  let finalPdData = pdData.map((it) => ({ ...it }))

  delegationTracker.forEach((delegation, index) => {
    const delegatedTask = finalPdData.find((it) => it.id == delegation.process_id)
    let removedProcessId = null

    if (delegatedTask?.from_process_ids == null) {
      finalPdData.forEach((parentNode) => {
        if (parentNode.to_process_ids && parentNode.to_process_ids.includes(delegatedTask.id)) {
          parentNode.to_process_ids = parentNode.to_process_ids.filter((pid) => {
            if (pid === delegatedTask.id) {
              removedProcessId = pid
              return false
            }
            return true
          })
        }
      })

      const delegationNode = {
        ...delegation,
        created_at: delegatedTask.created_at,
        modified_at: delegation.delegated_at,
        created_by: delegation.delegated_by,
        modified_by: delegation.delegated_to,
        from_process_ids: [],
        to_process_ids: removedProcessId ? [removedProcessId] : [delegatedTask.id],
        id: delegatedTask.id + '_delegated_' + (index + 1),
        activity_template_name: delegatedTask.activity_template_name,
        status: 'delegated',
        assignee: delegation.delegated_by,
      }

      delegatedTask.from_process_ids = [delegationNode.id]
      delegatedTask.created_at = delegationNode.delegated_at

      finalPdData.push(delegationNode)
    } else {
      const previousNode = finalPdData.find((it) => it.id == delegatedTask?.from_process_ids[0])

      finalPdData.forEach((parentNode) => {
        if (parentNode.to_process_ids && parentNode.to_process_ids.includes(delegatedTask.id)) {
          parentNode.to_process_ids = parentNode.to_process_ids.filter((pid) => {
            if (pid === delegatedTask.id) {
              removedProcessId = pid
              return false
            }
            return true
          })
        }
      })

      const delegationNode = {
        ...delegation,
        created_at: delegatedTask.created_at,
        modified_at: delegation.delegated_at,
        created_by: delegation.delegated_by,
        modified_by: delegation.delegated_to,
        from_process_ids: delegatedTask.from_process_ids,
        to_process_ids: removedProcessId ? [removedProcessId] : [delegatedTask.id],
        id: delegatedTask.id + '_delegated_' + (index + 1),
        activity_template_name: delegatedTask.activity_template_name,
        status: 'delegated',
        assignee: delegation.delegated_by,
      }

      previousNode.to_process_ids = [...(previousNode.to_process_ids || []), delegationNode.id]
      previousNode.to_process_ids = [...new Set(previousNode.to_process_ids)]
      previousNode.modified_at = delegationNode.delegated_at

      delegatedTask.from_process_ids = [delegationNode.id]
      delegatedTask.created_at = delegationNode.delegated_at
      delegatedTask.assignee = delegation.delegated_to

      finalPdData.push(delegationNode)
    }
  })

  return finalPdData
}

const ParallelRouteTimeline = ({
  processReferenceNum,
  processTemplateId,
  openProcessData = () => {},
  fieldOfDMS = {},
  isDMS = false,
  onDeleteFromNode,
}) => {
  const navigate = useNavigate()
  const { user } = useAuthContext()
  const [pdDataFinal, setPdDataFinal] = useState([])
  const [docMap, setDocMap] = useState({})

  const buildPairs = (tpl, ref) => {
    if (Array.isArray(tpl) && Array.isArray(ref)) {
      return tpl
        .map((t, i) => ({
          process_template_id: Number(t),
          process_reference_num: Number(ref[i]),
        }))
        .filter(
          (p) => !Number.isNaN(p.process_template_id) && !Number.isNaN(p.process_reference_num),
        )
    }

    const t = Number(tpl)
    const r = Number(ref)

    if (!Number.isNaN(t) && !Number.isNaN(r)) {
      return [{ process_template_id: t, process_reference_num: r }]
    }

    return []
  }

  const pairs = useMemo(
    () => buildPairs(processTemplateId, processReferenceNum),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(processTemplateId), JSON.stringify(processReferenceNum)],
  )

  useEffect(() => {
    if (!user || !pairs.length) return
    ;(async () => {
      const { pdData, delegationTrackerData, docMap } = await timelineService.getTimelineData(
        user,
        pairs,
      )

      const finalPdData = considerDelegation(pdData, delegationTrackerData)
      setPdDataFinal(finalPdData)
      setDocMap(docMap)
    })()
  }, [user, pairs])

  const workOnTask = (pd) => {
    navigate(`/process-data/${pd.id}/${pd.activity_template_id}`)
  }

  return (
    <Workflow
      nodes={pdDataFinal}
      openProcessData={openProcessData}
      openTask={workOnTask}
      docMap={docMap}
      isDMS={isDMS}
      fieldOfDMS={fieldOfDMS}
      onDeleteFromNode={onDeleteFromNode}
    />
  )
}

export default ParallelRouteTimeline
